import axios from 'axios';

// const baseURL = process.env.NODE_ENV === 'development'
//     ? process.env.REACT_APP_DOMAIND
//     : process.env.REACT_APP_DOMAINP;

// const baseURL = 'https://api.dbdesign.io:3000/';
const baseURL = 'http://localhost:3003/';

const instance = axios.create({ baseURL, withCredentials: true });

export default instance;
